import { render } from "./static-content-list.vue?vue&type=template&id=1bde6e56"
import script from "./static-content-list.vue?vue&type=script&lang=js"
export * from "./static-content-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__